import { Card, CardContent } from "../../../shared/components/ui/Card";
import { Box, Typography, useTheme } from "@mui/material";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import type { EventStatistics } from "../services/dashboardService";


ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

interface ParticipantsBarChartProps {
  events: EventStatistics[];
}

export function ParticipantsBarChart({ events }: ParticipantsBarChartProps) {
  const theme = useTheme();

  const data = {
    labels: events.map(e => e.eventTitle),
    datasets: [
      {
        label: "Participantes",
        data: events.map(e => e.participantsCount),
        backgroundColor: theme.palette.secondary.main,
      },
    ],
  };


const options = {
  responsive: true,
  plugins: {
    legend: { 
      display: true,

      labels: { color: theme.palette.text.primary } 
    },
    title: { display: false },
    tooltip: {
      backgroundColor: theme.palette.background.paper,
      titleColor: theme.palette.text.primary,
      bodyColor: theme.palette.text.primary,
    },
  },
  scales: {
    x: {
      ticks: { display: false }, 
      grid: { color: theme.palette.divider },
    },
    y: {
      beginAtZero: true,
      ticks: { color: theme.palette.text.primary },
      grid: { color: theme.palette.divider },
    },
  },
};


  return (

<Card sx={{ minHeight: 320 }}>
  <CardContent>
    <Typography variant="subtitle1" fontWeight={600} mb={1}>
      Participantes por Evento
    </Typography>
    <Box sx={{ height: 300, width: '100%' }}>
      <Bar data={data} options={options} />
    </Box>
  </CardContent>
</Card>

  );
}